import React from "react";
import "./X013.css";

function X013(props) {
  const { className } = props;

  return (
    <div className={`x01-7 ${className || ""}`}>
      <div className="dashboard-10 avenir-medium-cod-gray-10px">COPY LINK</div>
    </div>
  );
}

export default X013;
